import { render, staticRenderFns } from "./GenitorCard.vue?vue&type=template&id=7a5f7e6f&scoped=true&"
import script from "./GenitorCard.vue?vue&type=script&lang=js&"
export * from "./GenitorCard.vue?vue&type=script&lang=js&"
import style0 from "./GenitorCard.vue?vue&type=style&index=0&id=7a5f7e6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5f7e6f",
  null
  
)

export default component.exports